import { mixins, styled, theme, utils } from 'ui/theme';
import { ButtonSolid, Card, Picture, Text } from 'ui/components/primitives';

import { ProductCard } from '../../Product';

const comboComponentsStyles = {
  ActionButton: styled(ButtonSolid)`
    align-items: center;
    display: flex;
    margin-top: ${theme.space[2]};
  `,

  Button: styled(ButtonSolid)`
    align-items: center;
    display: flex;
    gap: ${theme.space[2]};
  `,

  Picture: styled(Picture)`
    img {
      margin: 0 auto;
      display: flex;
    }
  `,

  ProductCard: styled(ProductCard.Card)`
    ${utils.media.between('s').and('l')`
      display: contents;
    `}
  `,

  WrapperButton: styled('div')`
    background: ${theme.colors.build.lightLight};

    ${utils.media.max('l')`
      border-radius: 0;
      bottom: 0;
      left: 0;
      position: fixed;
      width: 100%;
      z-index: ${theme.zIndices.sticky};
    `}
  `,

  Combo: styled('div')`
    grid-column: 1 / -1;

    ${utils.media.min('l')`;
    ${utils.grid.colspan[3]};
  `}
  `,

  Container: styled('div')`
    ${mixins.baseFont};
    display: flex;
    flex-direction: column;
    gap: ${theme.space[2]};
  `,

  Detail: styled('div')`
    background: ${theme.colors.build.lightDark2};
    width: 100%;
  `,

  Divider: styled('div')`
    border-top: 1px solid ${theme.colors.build.lightDark1};
    height: 1px;
    margin: ${theme.space[2]} 0;
    width: 100%;

    ${utils.media.max('m')`
      display: none;
    `}
  `,

  QuantityWrapper: styled('div')`
    margin-top: ${theme.space[2]};
  `,

  PriceWrapper: styled('div')`
    align-items: center;
    background: ${theme.colors.build.lightDark1};
    border-radius: ${theme.radii.small};
    display: flex;
    justify-content: space-between;
    margin: ${theme.space[1]} ${theme.space[0]};
    padding: ${theme.space[2]};
  `,

  WrapperCarousel: styled('div')`
    margin: 0 calc(-1 * ${theme.space[4]});
    overflow: hidden;
    position: relative;

    ${utils.media.min('l')`
      padding: 0;
      margin: 0;
      overflow: initial;
    `}
  `,

  Skus: styled('div')`
    background: ${theme.colors.build.lightDark2};
    grid-column: 1 / -1;
    margin-bottom: ${theme.space[1]};
    padding: ${theme.space[6]} ${theme.space[4]};

    ${utils.media.min('l')`
      padding: ${theme.space[6]} ${theme.space[10]};
    `}

    &:nth-first-of-type(1) {
      border-radius: ${theme.radii.small} ${theme.radii.small} 0 0;
    }

    &:nth-last-of-type(1) {
      border-radius: 0 0 ${theme.radii.small} ${theme.radii.small};
    }

    ${utils.media.min('l')`
      grid-column: 4 / span 9;
    `}
  `,

  Sku: styled(Card)`
    border: solid ${theme.borderWidths.thin} ${theme.colors.build.lightDark1};
    color: ${theme.colors.build.darkLight};
    display: flex;
    display: flex;
    flex-flow: column;
    gap: ${theme.space[2]};
    height: 100%;
    justify-content: flex-end;
  `,

  Slider: styled('div')`
    width: calc(100% / 2);

    ${utils.media.min('l')`
      width: calc(100% / 5);
    `}
  `,

  Tag: styled('div')`
    ${mixins.baseFont};
    align-items: end;
    background: ${theme.colors.build.lightDark1};
    border-radius: ${theme.radii.small};
    box-shadow: 0 0 0 1px ${theme.colors.status.alert.standard};
    color: ${theme.colors.build.darkLight};
    display: inline-flex;
    gap: ${theme.space[1]};
    height: ${theme.space[6]};
    margin: ${theme.space[2]} 0 ${theme.space[4]} 0;
    padding: ${theme.space[1]} ${theme.space[2]};

    &[data-completed='true'] {
      box-shadow: 0 0 0 1px ${theme.colors.status.success.standard};
    }
  `,

  Text: styled(Text)`
    ${utils.lineClamp(3)};
  `,
};

export default comboComponentsStyles;
